import { Injectable } from '@angular/core';
import { StorageKeys } from '@core/enums';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  setItem(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  getItem(key: string): string {
    return sessionStorage.getItem(key) ?? '';
  }

  setObject(key: string, object: unknown): void {
    sessionStorage.setItem(key, JSON.stringify(object));
  }

  getObject<T>(key: string, from = sessionStorage): T {
    return JSON.parse(from.getItem(key) ?? '{}') as T;
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }

  isDataFromStorage(): boolean {
    return sessionStorage.getItem(StorageKeys.IS_SHELL) === 'true';
  }
}
